/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Ui
 * Developer: Jayd Saucedo <jayd@sauce.do>
 * Date: 1/11/18
 * Copyright All Rights Reserved
 */

import { connect } from 'react-redux';
import ReportLinkComponent from 'components/ReportLink';
import { getToken } from 'selectors/tokenSelectors';

const mapStateToProps = (state) => {
  const token = getToken(state);
  return {
    token,
  };
};

const ReportLinkContainer = connect(mapStateToProps)(ReportLinkComponent);

export default ReportLinkContainer;
